import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import 'ag-grid-enterprise';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
//import "./Library.css";
import { TopBar } from "../../shared/topBar/TopBar";
import { UrlPath } from "../../../config/routeConfig";
import { SBADropDown, SBAMultiSelect, SBAComboBox, SBAMultiSelectCheck, SBAMulticolumnCheck } from "../../UiComponents/SBADropDown";
import { SBAEditor } from '../../UiComponents/SBAEditor';
import { AgGridReact } from 'ag-grid-react';
import { sbaAxios } from "../../utils/sbaAxios";
import { getCategory, getActivityEntityType, getActivityType, getActivityEntities } from "../../actions/investmentAction";
import { useDispatch, useSelector } from "react-redux";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { getManagerContacts } from "../../actions/CommonAction";
import { getSubStrategy } from "../../actions/assetDetailsActions";
import { getPortfolioListAction } from '../../actions/portfolioListAction'
import { getAllUsers } from "../../actions/UserAction";
import { getAssetLists } from "../../actions/assetListAction";
import { insertOrUpdateActivityDetails, insertOrUpdateActivityDocument,getcategory, getActivityentityType, getActivityEntity,getDocumentStatus} from "../../../config/apiConfig";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import { SBNotify } from "../../utils/sbNotify";
import moment from "moment";
import { SBATextBox } from "../../UiComponents/SBATextBox";
import { getAssetNotesTabDetails } from "../../actions/assetNotestabAction";
import { getAssetDocuments } from "../../actions/assetDocumentsActions";
import { SBDatePicker } from "../../UiComponents/SBDatePicker";
import {  useLocation } from "react-router-dom";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";

export const InvestorAdd = () => {
    const Level = [
        { BreadCrumb: "Investor >", Routes: `${UrlPath.DocumentInvestor}` },
    ];
    return <>
        <div>
            <TopBar label={"Investor Add"} />
            <BreadCrumbs Levels={Level} />
        </div>
        <InvestmentAdd />
    </>
}
export const InvestmentAdd = ({ Modal, selectedAsset, SelectedActivity, SelectedCategory, setDrawerSet, ActivityDisable, afterSave, ShowDocuments }) => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const Gstate = useSelector((state) => state) || {};
    
    const AssetListDDL = Gstate.assetList.assetList || [];
    // const Categoryfilter = useSelector((state) => state.Category.Category) || [];
    // const Category = Categoryfilter.filter(item => item.ActivitySubType !== "All")
    const ActivityTypefilter = useSelector((state) => state.ActivityType.ActivityType) || [];
    const ActivityType = ActivityTypefilter.filter(item => item.ActivityType !== "All")
  

    const [comments, setcomments] = useState();
    const gridRef = useRef();
    
    const [IsActivityDisable, setIsActivityDisable] = useState(false);
    const [ActivityentityType, setActivityentityType] = useState([]);
   // const ActivityentityType = useSelector((state) => state.ActivityentityType.ActivityentityType) || [];
    const [typeselected, setTypeSelected] = React.useState({ value: ActivityentityType, allSelected: true });
    const [EntityTypeIds, setEntityTypeIds] = useState(ActivityentityType);
    // const Entities = useSelector((state) => state.ActivityEntity.Activityentity) || [];
    const EntityTypeId = ActivityentityType.map(item => item.ActivityEntityTypeId).join(',');
    const [entities,setEntities]=useState([]);

    const [Entitytype, SetEntitytype] = useState([]);
    const [Status,setStatus]=useState([]);
    const[documentStatusId,setDocumentStatusId]=useState([]);
    const [Category,setCategory]=useState([]);
    const [categoryFilter,setcategoryFilter]=useState([]);
    const str=null;
    useEffect(() => {
        document.title = `Investor Add`;
    }, []);
    useEffect(() => {
        // dispatch(getCategory(2));
        getCategoryData();
        dispatch(getManagerContacts());
        dispatch(getSubStrategy());
        dispatch(getPortfolioListAction());
        dispatch(getAllUsers());
        dispatch(getAssetLists());
        dispatch(getActivityEntityType(2));
        dispatch(getActivityType());
        // dispatch(getActivityEntities(EntityTypeId, str, 2));
        getEntitiesData(EntityTypeId,str)
        getEntities();
        getDocStatus(0);
    }, []);
    const getEntitiesData = async (EntitytypeId,str) => {
        try {

            const response = await sbaAxios({
                url: `${getActivityEntity}ActivityEntityTypeIds=${EntitytypeId}&SearchString=${str}&activitySourceId=2`,
                method: 'get',
            });
            const data = response;
            setEntities(data);
        } catch (error) {
            console.error("Error fetching entities from API:", error);
        }
    };
    const getCategoryData = async () => {
        try {

            const response = await sbaAxios({
                url: `${getcategory}${2}`,
                method: 'get',
            });
            const data =response.filter(item => item.ActivitySubTypeId !== -1);
            setCategory(data);
            setcategoryFilter(data);
        } catch (error) {
            console.error("Error fetching entities from API:", error);
        }
    };

    const getDocStatus = async (ActivitysubTypeId) => {
        try {

            const response = await sbaAxios({
                url: `${getDocumentStatus}${ActivitysubTypeId}`,
                method: 'get',
            });
            const data = [{
                "DocumentStatusId": 0,
                "DocumentStatusName": "",
                "DefaultFlag": false
            },...response];
            setStatus(data);
            if(data.length>1)
            setDocumentStatusId({ DocumentStatusId:"-1", DocumentStatusName:"Select" })
            else
            setDocumentStatusId({ DocumentStatusId: data[0].DocumentStatusId, DocumentStatusName: data[0].DocumentStatusName })
        } catch (error) {
            console.error("Error fetching entities from API:", error);
        }
    };

    const [selectedManager, setSelectedManager] = useState([]);
    const [assetId, SetAssetId] = useState([]);
    const [PortfolioId, SetPortfolioId] = useState([]);
    //const [selectedActivityTypeId, SetselectedActivityTypeId] = useState([]);
    const [selectedActivityTypeId, SetselectedActivityTypeId] = useState({
        ActivityTypeId: 2, // Set default ActivityTypeId
        ActivityType: 'Document' // Set default ActivityType
    });
    const [subject, setsubject] = useState();
    const [assetDDLlist, setAssetDDLlist] = useState(AssetListDDL);
    const [managerId, SetmanagerId] = useState([]);
    const [SubStrategyId, SetSubStrategyId] = useState([]);
    const [userId, SetuserId] = useState([]);
    const [ActivitycategorySubTypeIds, setActivitycategorySubTypeIds] = useState([]);
    const [PartnerLetter, SetPartnerLetter] = useState(false);
    const [ManagerLetter, SetManagerLetter] = useState(false);
    const [selectedEventDate, setSelectedEventDate] = useState(new Date());

    const [selectedFiles, setSelectedFiles] = useState([]);
    const [showFiles, setshowFiles] = useState([]);
    const [resulttrim, setResulttrim] = useState();
    const [saving,setSaving]=useState(false);
    const [fileError, setFileError] = useState("");

    const locationData = useLocation();

    useEffect(() => {
        setAssetDDLlist(AssetListDDL);
        SetselectedActivityTypeId(SelectedActivity != undefined ? {
            ActivityTypeId: 2 || '',
            ActivityType: 'Document' || ''
        } : "");
        setActivitycategorySubTypeIds(SelectedCategory != undefined ? {
            ActivitySubTypeId: SelectedCategory[0].ActivitySubTypeId || '',
            ActivitySubType: SelectedCategory[0].ActivitySubType || ''
        } : "")
        setIsActivityDisable(ActivityDisable);
        setEntityTypeIds(ActivityentityType);
    }, [ActivityentityType]);

 //State  Variable.....
 const stateType = locationData.state !==null? locationData.state.Type === undefined ? null : locationData.state.Type:null;
 const stateNames = locationData.state !==null? locationData.state.Names === undefined ? null : locationData.state.Names:null;
 const stateActivity = locationData.state !==null? locationData.state.Activity === undefined ? null : locationData.state.Activity:null;
 const stateCategory = locationData.state !==null? locationData.state.Category === undefined ? null : locationData.state.Category:null;
 

  
    const ActivityTypeDDChange = (e) => {
        SetselectedActivityTypeId({ ActivityTypeId: 2, ActivityType: 'Document' });
    }
    const commentsChange = (event) => {
        setcomments(event.html);
    }

    const activityEntityTypeDDChange = (e) => {
       
        const currentSelectAll = typeselected.value.some((i) => i.ActivityEntityType.trim() === "All");
        const nextSelectAll = e.value.some((i) => i.ActivityEntityType.trim() === "All");
        let value = e.value;
        const currentCount = typeselected.value.length;
        const nextCount = value.length;

        if (
            nextCount > currentCount &&
            !currentSelectAll &&
            !nextSelectAll &&
            ActivityentityType.length - 1 === nextCount
        ) {
            value = ActivityentityType;
        } else if (
            nextCount < currentCount &&
            currentCount === ActivityentityType.length &&
            currentSelectAll &&
            nextSelectAll
        ) {
            value = value.filter((v) => v.ActivityEntityType.trim() !== "All");
        } else if (!currentSelectAll && nextSelectAll) {
            value = ActivityentityType;
        } else if (currentSelectAll && !nextSelectAll) {
            value = [];
        }
        setTypeSelected({ value });
        setEntityTypeIds(value);
        const EntityType = value.map(item => item.ActivityEntityTypeId).join(',');
        dispatch(getActivityEntities(EntityType,str,2));
    };


    const getEntities = async () => {
        try {

            const response = await sbaAxios({
                url: `${getActivityentityType}${2}`,
                method: 'get',
            });
            const data = response;
            setActivityentityType(data);
        } catch (error) {
            console.error("Error fetching entities from API:", error);
        }
    };

  
    const subjectChange = (event) => {

        setsubject(event.target.value);
        const result = SBATextBox(event.target.value)
        setResulttrim(result);
    }
    const CategoryDDChange = (e) => {

        setActivitycategorySubTypeIds({ ActivitySubTypeId: e.value.ActivitySubTypeId, ActivitySubType: e.value.ActivitySubType })
        getDocStatus(e.value.ActivitySubTypeId);
    };
    const StatusDDChange = (e) => {

        setDocumentStatusId({ DocumentStatusId: e.value.DocumentStatusId, DocumentStatusName: e.value.DocumentStatusName })

    };

    const TypeDDChange = (e) => {
        SetEntitytype({ ActivityTypeId: e.value.ActivityTypeId, ActivityType: e.value.ActivityType })
        if(e.value.ActivityTypeId===1)
        {
            const subType=categoryFilter.filter(item => item.ActivitySubType === "General Note");
        setActivitycategorySubTypeIds({ ActivitySubTypeId: subType[0].ActivitySubTypeId, ActivitySubType: subType[0].ActivitySubType })
        }
    else
{
    const subType=categoryFilter.filter(item => item.ActivitySubType !== "General Note");
    setCategory(subType);
    setActivitycategorySubTypeIds();
}
}

    const entitiesDDChanged = (e) => {
       
        SetAssetId([...e.value]);
    };
    const gridValueFormatter = (params) => {
        return params.value;
    };
    const eventDateChange = (newDate) => {
        setSelectedEventDate(newDate);
    }

    const allowedExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'png', 'jpeg'];
    const handleFileChange = (event) => {
        const newFiles = event.target.files;

        if (newFiles.length > 0) {
            const updatedFiles = [];
            const startingRowIndex = 0;

            for (let i = 0; i < newFiles.length; i++) {
                const file = newFiles[i];
                const fileName = file.name;
                const lastDotIndex = fileName.lastIndexOf('.');
                const extension = lastDotIndex >= 0 ? fileName.substring(lastDotIndex + 1) : '';
                // Check if the extension is allowed
                if (!allowedExtensions.includes(extension.toLowerCase())) {
                    setFileError(`Unsupported file format: .${extension}`);
                    continue; // Skip the rest if the format is invalid
                }
                setFileError("");
                const reader = new FileReader();
                reader.onload = function () {
                    if (reader.result) {
                        const arrayBuffer = reader.result;
                        const base64String = arrayBufferToBase64(arrayBuffer);
                        const rowIndex = startingRowIndex + i;
                        updatedFiles.push({ file, fileName, extension, base64String, rowIndex });
                        setSelectedFiles(updatedFiles);
                    }
                };

                reader.readAsArrayBuffer(file);
            }
        }

    };

    const arrayBufferToBase64 = (arrayBuffer) => {
        const binary = [];
        const bytes = new Uint8Array(arrayBuffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary.push(String.fromCharCode(bytes[i]));
        }
        return btoa(binary.join(''));
    };
    const cancelButtonClick = (e) => {
        NavigateBack();
    };
    const DeleteButtonRenderer = (props) => {
        const handleDeleteClick = () => {
            const updatedFiles = selectedFiles.filter((item, index) => item.rowIndex !== props.data.rowIndex);
            setSelectedFiles(updatedFiles);
          
            // Set display to none
            document.getElementById('fileInput').style.display = 'none';

            // Reset the file input value
            document.getElementById('fileInput').value = '';

            // Restore display
            document.getElementById('fileInput').style.display = 'block';
            // Force re-render if needed
        }
        return (
            <div className="actions-cell">
                <i
                    className="fas fa-trash"
                    style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
                    onClick={handleDeleteClick}
                ></i>
            </div>
        );
    };

    const columnDefs = [
        {
            field: "fileName",
            headerName: "File Name",
            //cellRenderer: HyperlinkRenderer,
            sort: "asc",
            pinned: "left",
            minWidth: 442.47,
            filter: "agTextColumnFilter",
            valueFormatter: gridValueFormatter,
            tooltipField: 'FileName',
            editable: true,
        },
        {
            headerName: "",
            field: "Delete",
            minWidth: 442.47,
            cellRenderer: DeleteButtonRenderer,
        }
    ];
    const defaultColDef = {
        sortable: true, filter: true, floatingFilter: true, flex: 1, resizable: true,
    }

    const saveInvestment = async (event) => {
 
        await gridRef.current.api.stopEditing();
        let saveSuccess = true;
        setSaving(true)
        event.preventDefault();
        const activityXRefs = [];
        if (!Modal) {
            if (assetId.length > 0) {
                activityXRefs.push(
                    ...assetId.map((asset) => ({
                        activityXRefId: 0,
                        activityId: 0,
                        activityEntityTypeId: asset.ActivityEntityTypeId,
                        activityEntityType: asset.ActivityEntityType,
                        entityId: asset.EntityId,
                        entityName: asset.EntityName,
                    }))
                );
            }
        }
        else if (Modal) {

            activityXRefs.push(
                {
                    activityXRefId: 0,
                    activityId: 0,
                    activityEntityTypeId: 1,
                    activityEntityType: "Asset",
                    entityId: selectedAsset.AssetId,
                    entityName: selectedAsset.AssetName,
                });

            activityXRefs.push(
                {
                    activityXRefId: 0,
                    activityId: 0,
                    activityEntityTypeId: 2,
                    activityEntityType: "Manager",
                    entityId: selectedAsset.ManagerContactId,
                    entityName: selectedAsset.ManagerContact,
                }
            );
        }
        if(!Entitytype?.ActivityTypeId || Entitytype?.ActivityTypeId==0)
        {
            SBNotify({ Msg: "Please Select Activity Type", type: "error" });
            saveSuccess = false;
            setSaving(false)
            return;
        }
        if (!ActivitycategorySubTypeIds?.ActivitySubTypeId || ActivitycategorySubTypeIds?.ActivitySubTypeId === -1 || ActivitycategorySubTypeIds?.ActivitySubTypeId === 0 ) {
            SBNotify({ Msg: "Please Select Category Type", type: "error" });
            saveSuccess = false;
            setSaving(false)
            return;
        }
        if ((resulttrim == false) || (!subject)) {
            SBNotify({ Msg: "Subject is Required", type: "error" });
            setSaving(false);
            saveSuccess = false;
            return;
        }
        if (assetId.length < 1 && !Modal) {
            SBNotify({ Msg: "Please Select Account/Contact", type: "error" });
            saveSuccess = false;
            setSaving(false);
            return;
        }
        const data = {
            "activitySummary": {
                "activityId": 0,
                "activitySourceId": 2,
                "activityTypeId": Entitytype.ActivityTypeId,
                //"activityTypeId": 2,
                "activitySubTypeId": ActivitycategorySubTypeIds.ActivitySubTypeId,
                "activityName": subject,
                "activityDescription": comments ? comments.replace(/<\/?[^>]+(>|$)/g, "") : null,
                "activityDescriptionHtml": comments ? comments : null,
                "activityDate": selectedEventDate,
                "documentStatusId": documentStatusId.DocumentStatusId==="-1"?0:documentStatusId.DocumentStatusId
            },
            "activityDetails":
            {

                "activityDetailId": 0,
                "activityId": 0,
                "emailMessageId": "",
                "emailFrom": "",
                "emailTo": "",
                "mailCc": "",
                "emailSubject": "",
                "emailBody": "",
                "emailBodyHtml": "",
                "emailDate": selectedEventDate,
                "meetingDate": selectedEventDate,
            },
            "activityXRefs": activityXRefs,
            "modifiedBy": 0,
        };
        const Documentdetails = (activityid) => {
            const DocumentData = selectedFiles.map((obj) => ({
                ActivityId: activityid,
                DocumentId: 0,
                DocumentName: obj.fileName,
                DocumentContent: obj.base64String,
                DocumentExtension: "." + obj.extension,
                DocumentDate: selectedEventDate,
                RuleId: 0,
                IsPartnerLetter: PartnerLetter,
                IsEmailForwarded: false,
                IsReturnsProcessed: false,
                IsManagerLetter: ManagerLetter,
                ModifiedBy: 0,
                ActivitySourceId: 2,
                DocumentStatusId: documentStatusId.DocumentStatusId==="-1"?0:documentStatusId.DocumentStatusId
            }));
            sbaAxios({
                url: `${insertOrUpdateActivityDocument}`,
                method: "post",
                data: DocumentData,
            }).then((response) => {
                if (!Modal) {
                    toast.success("Investor Documents Saved Successfully", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });


                }


            })

                .catch((error) => {
                    console.error(error);
                });

        }
       
        
       
        // Documents are optional For all case 
        // if (selectedFiles.length < 1 && !Modal ) {
        //     SBNotify({ Msg: "Please Upload Document", type: "warning" });
        //     saveSuccess = false;
        // }


        if (saveSuccess) {

            sbaAxios({
                url: `${insertOrUpdateActivityDetails}`,
                method: "post",
                data: data,
            })
                .then((response) => {
                    setSaving(false);
                    if (response > 0) {
                        if (selectedFiles.length > 0) {

                            Documentdetails(response)

                        }
                        else if (Modal) {

                            if (selectedActivityTypeId.ActivityTypeId === 1) {

                                toast.success("Investor Note Saved Successfully", {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    theme: "light",
                                });
                            }

                            if (selectedActivityTypeId.ActivityTypeId === 2) {

                                toast.success("Investor  Saved Successfully", {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    theme: "light",
                                });
                            }


                        }

                        else {
                            setTimeout(() => {
                            toast.success("Investor  Saved Successfully",
                                {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    theme: "light",
                                });
                            }, 500);
                        }
                        
                        if (!Modal) {
                            NavigateBack()
                        }
                        else if (Modal) {

                            dispatch(getAssetNotesTabDetails(selectedAsset.AssetId));
                            dispatch(getAssetDocuments(selectedAsset.AssetId));
                            afterSave(selectedActivityTypeId.ActivityType);
                            setDrawerSet(false);
                        }

                 

                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        };
    };
    const NavigateBack = (e) => {

        const state = locationData?.state;
        history(`${UrlPath.DocumentInvestor}`,
            {
                state: {
                    maintainState:true
                }
            });
    };
    const onCellValueChanged = (params) => {
        const updatedDocuments = selectedFiles.map(doc =>
            doc.id === params.data.id ? { ...doc, DocumentName: params.data.DocumentName } : doc
        );
        setSelectedFiles(updatedDocuments);
    }
    return (
<>{saving ? <><LoadingScreen/></> : 

        <div className="container-fluid" >
            <div style={Modal ? { marginTop: "-25px" } : {}}>

                <div className="d-flex justify-content-end gap-2">
                    {!Modal && <button type="submit" className="s-sm-btn me-1" onClick={cancelButtonClick} > Cancel</button>}
                    <button type="submit" className="p-sm-btn mx-1" disabled={saving} onClick={saveInvestment}>Save </button>
                   {/* <button type="submit" className="p-sm-btn mx-1" > Save & Email</button>*/}


                </div>
                <br />
                <div>
                    <div >
                        <div className="row-md-12 d-flex gap-1">
                            <div className={Modal ? `col-md-12` : `col-md-6`}>
                                <div class="row detail p-3  m-0">

                                    <div className="row">

                                        {/*<div className="col-md-4">*/}
                                        {/*    <label*/}
                                        {/*        for="select fund"*/}
                                        {/*        className="mb-1 ms-2 fw-semibold fs-12"*/}
                                        {/*    >*/}
                                        {/*        Activity Type*/}
                                        {/*        <span className="mandatory">*</span>*/}

                                        {/*    </label>*/}
                                        {/*    <div>*/}
                                        {/*        <SBADropDown*/}
                                        {/*            className="w-85"*/}
                                        {/*            data={ActivityType}*/}
                                        {/*            value={selectedActivityTypeId}*/}
                                        {/*            valueField="ActivityTypeId"*/}
                                        {/*            textField="ActivityType"*/}
                                        {/*            onChange={ActivityTypeDDChange}*/}
                                        {/*            filterable={true}*/}
                                        {/*            popupSettings={{ className: Modal ? `modalDD` : `` }}*/}
                                        {/*            disabled={IsActivityDisable}*/}
                                        {/*        />*/}
                                        {/*    </div>*/}
                                        {/*</div>*/}
                                        <div className="col-md-4">
                                            <label
                                                htmlFor="select-fund"
                                                className="mb-1 ms-2 fw-semibold fs-12"
                                            >
                                                Activity Type
                                                <span className="mandatory">*</span>
                                            </label>
                                            <div>
                                                <SBADropDown
                                                    className="w-85"
                                                    data={ActivityType}
                                                    value={Entitytype}
                                                    valueField="ActivityTypeId"
                                                    textField="ActivityType"
                                                    onChange={TypeDDChange}
                                                    filterable={true}

                                                />

                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <label
                                                for="select fund"
                                                className="mb-1 ms-2 fw-semibold fs-12"
                                            >
                                                Category <span className="mandatory">*</span>
                                            </label>
                                            <div>

                                                <SBADropDown
                                                    className="w-85"
                                                    textField={"ActivitySubType"}
                                                    valueField={"ActivitySubTypeId"}
                                                    data={Category}
                                                    value={ActivitycategorySubTypeIds}
                                                    onChange={CategoryDDChange}
                                                    filterable={true}
                                                    popupSettings={{ className: Modal ? `modalDD` : `` }}
                                                    disabled={Entitytype?.ActivityTypeId==1}
                                                />
                                            </div>

                                        </div>
                                        <div className="col-md-4">
                                            <label
                                                for="select fund"
                                                className="mb-1 ms-2 fw-semibold fs-12"
                                            >
                                                Event Date
                                            </label>
                                               <div>
                                            <SBDatePicker className="w-75" id="eventDate"
                                                defaultValue={selectedEventDate ? moment(selectedEventDate)
                                                    : null}
                                                onChange={eventDateChange}>
                                                    </SBDatePicker>
                                             </div>
                                        </div>


                                    </div>
                                    <div className="row" style={{ marginTop: "20px" }}>
                                        <div className="col-md-6">
                                            <label
                                                for="select fund"
                                                className="mb-1 ms-2 fs-12 fw-semibold"
                                            >
                                                Subject <span className="mandatory">*</span>
                                            </label>
                                            <input
                                                className="w-125 input-default form-control"
                                                type="text"
                                                placeholder="Type here"
                                                onChange={subjectChange}
                                                Value={subject}
                                            //onKeyUp={loadOnEnter}
                                            />

                                        </div>
                                        { Entitytype.ActivityTypeId==2 && 
                                        <div className="col-md-6">
                                            <label
                                                for="select fund"
                                                className="mb-1 ms-2 fs-12 fw-semibold"
                                            >
                                                Document Status                                             </label>
                                            <SBADropDown
                                              className="w-85"
                                              textField={"DocumentStatusName"}
                                              valueField={"DocumentStatusId"}
                                              data={Status}
                                              value={documentStatusId}
                                              onChange={StatusDDChange}
                                              filterable={true}
                                              popupSettings={{ className: Modal ? `modalDD` : `` }}

                                            ></SBADropDown>

                                        </div>
}
                                    </div>
                                    <div className="row" style={{ marginTop: "10px" }}>
                                        <label
                                            for="select fund"
                                            className="mb-1 ms-2 fs-12 fw-semibold">
                                            Description:
                                        </label>
                                        <SBAEditor id="editor" onChange={commentsChange} defaultContent={comments} editorHeight={300} setContent={setcomments} />

                                    </div>
                                    {!Modal && (
                                        <div className="row" style={{ marginTop: "10px" }}>
                                            <div>
                                                <label
                                                    for="select fund"
                                                    className="mb-1 ms-2 fs-12 fw-semibold"
                                                >
                                                    Tags:
                                                </label>
                                                <input
                                                    className="w-400 input-default form-control"
                                                    type="text"

                                                    //onChange={subjectChange}
                                                    Value={''}
                                                    //onKeyUp={loadOnEnter}
                                                    style={{ height: '60px' }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <div className="row" style={{ marginTop: "10px" }}>
                                        <div style={{ position: "relative" }}>
                                            <input
                                                type="file"
                                                id="fileInput"
                                                className="input-hidden"
                                                onChange={handleFileChange}
                                            />
                                            {fileError && <p style={{ color: 'red' }}>{fileError}</p>}
                                        </div>
                                    </div>

                                    <div className="row" style={{ marginTop: "10px" }}>

                                        <div className="ag-theme-alpine" style={{ width: '100%', height: '300px' }}>
                                            <AgGridReact
                                                columnDefs={columnDefs}
                                                rowData={selectedFiles}
                                                defaultColDef={defaultColDef}
                                                // domLayout= {'autoHeight'}
                                                onCellValueChanged={onCellValueChanged}
                                                    overlayNoRowsTemplate={`<span>${'No data Available'}</span>`}
                                                    ref={gridRef}
                                            >
                                            </AgGridReact>
                                        </div>
                                    </div>


                                </div>

                            </div>
                            {!Modal && <div className="col-md-6">

                                <div class="row detail p-3 m-0">

                                    <div className="row">

                                        <div className="col-md-12">
                                            <label className="mb-1 ms-2 fw-semibold fs-12">
                                                Type
                                            </label>
                                            <div className="col-lg-12 mb-4">
                                                <SBAMultiSelectCheck
                                                    className="w-75"
                                                    data={ActivityentityType}
                                                    dataItemKey="ActivityEntityTypeId"
                                                    textField="ActivityEntityType"
                                                    onChange={activityEntityTypeDDChange}
                                                    value={EntityTypeIds}
                                                    tags={
                                                        EntityTypeIds.length > 0
                                                            ? [
                                                                {
                                                                    text: `${EntityTypeIds.filter(item=>item.ActivityEntityType.trim()!=="All").length} items selected`,
                                                                    data: [...EntityTypeIds],
                                                                },
                                                            ]
                                                            : []
                                                    }
                                                    filterable={true}
                                                ></SBAMultiSelectCheck>
                                            </div>


                                        </div>
                                    </div>

                                   

                                    <div className="row" >

                                        <div className="col-md-12">
                                            <label
                                                for="select fund"
                                                className="mb-1 ms-2 fw-semibold fs-12"
                                            >
                                                Account/Contact
                                            </label>
                                            <div className="col-lg-12 mb-4">
                                                <SBAMulticolumnCheck
                                                    data={entities}
                                                    dataItemKey="EntityId"
                                                    textField="EntityName"
                                                    className="w-75"
                                                    onChange={entitiesDDChanged}
                                                    value={assetId}
                                                    placeholder="Please Select"
                                                    tags={
                                                        assetId.length > 0
                                                            ? [
                                                                {
                                                                    text: `${assetId.length} items selected`,
                                                                    data: [...assetId],
                                                                },
                                                            ]
                                                            : []
                                                    }
                                                    filterable={true}
                                                ></SBAMulticolumnCheck>
                                            </div>


                                        </div>
                                    </div>

                                  

                                </div>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer></ToastContainer>
        </div>

}</>
    );
};
